<template>
  <div class="login-container">
    <LoginTempl>
      <div class="left-content">
        <img :src="logo" alt="" class="logo">

        <div class="title-wrap">
          <span class="iconfont sys-logo">&#xe665;</span>
          <p class="sys-title">渠道沟通平台</p>
          <p v-if="env === 'uat'" class="sys-env">UAT</p>
        </div>
        <div>
          <el-form ref="dataForm" label-position="top" :model="form" :rules="rules" class="form-container">
            <!-- 防止浏览器记录密码自动填充 -->
            <!-- <div class="hidden-wrap">
              <div class="hidden-modal"></div>
              <div class="hidden-inner">
                <input name="loginCode" type="text" class="hidden-input" autocomplete>
                <input name="password" type="password" class="hidden-input" autocomplete>
              </div>
            </div> -->
            <!-- 防止浏览器记录密码自动填充 -->
            <el-form-item prop="loginCode" label="您的手机号码">
              <el-input v-model.trim="form.loginCode" type="text" name="loginCode" autocomplete="off" placeholder="请输入手机号码" clearable />
            </el-form-item>
            <!-- <transition name="login-transform" mode="out-in">
              <el-form-item v-if="form.loginType === 'ACCOUNT'" prop="loginPass" label="密码">
                <el-input
                  v-model.trim="form.loginPass"
                  type="password"
                  name="password"
                  autocomplete="off"
                  placeholder="请输入登录密码"
                  clearable
                  @keyup.enter.native="clickLoginBtn"
                />
                <p class="forget-tips" @click="forgetPass">忘记登录密码?</p>
              </el-form-item>
            </transition> -->
            <transition name="login-transform" mode="out-in">
              <el-form-item v-if="form.loginType === 'MOBILE'" prop="vcode" label="验证码">
                <el-input
                  v-model.trim="form.vcode"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入验证码"
                  clearable
                  class="code"
                  @keyup.enter.native="clickLoginBtn"
                />
                <el-button
                  type="primary"
                  class="code-btn"
                  :disabled="validPhone(form.loginCode) || isShowCountDown"
                  :loading="isCodeLoading"
                  @click="getVerificationCode"
                >
                  {{ codeMsg }}
                </el-button>
                <p v-if="form.loginType === 'MOBILE'" class="forget-tips" @click="noSMSCode">收不到短信验证码？</p>
              </el-form-item>
            </transition>

            <el-form-item class="login-btn-wrap">
              <el-button type="primary" class="login-btn" :disabled="isLoginBtnDisabled" :loading="isLoginLoading" @click="clickLoginBtn">登 录</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div class="login-channel-container">
          <p><span class="channel-title">其他登录方式</span></p>
          <div class="channel-content">
            <div class="channel-item" :class="{'is-active': form.loginType === 'MOBILE'}" @click="selectLoginType('MOBILE')">
              <svg-icon icon-class="phone" class="channel-icon" />
            </div>
            <div class="channel-item" :class="{'is-active': form.loginType === 'ACCOUNT'}" @click="selectLoginType('ACCOUNT')">
              <svg-icon icon-class="password" class="channel-icon" />
            </div>
            <div class="channel-item" :class="{'is-active': form.loginType === 'wechat'}" @click="selectLoginType('none')">
              <svg-icon icon-class="wechat" class="channel-icon" />
            </div>
            <div class="channel-item" :class="{'is-active': form.loginType === 'finger'}" @click="selectLoginType('none')">
              <svg-icon icon-class="finger" class="channel-icon" />
            </div>
          </div>
        </div> -->
      </div>
    </LoginTempl>

    <ModifyPass :is-show.sync="isShowModifyPass"></ModifyPass>
    <SetNewPass :is-show.sync="isShowNewPass"></SetNewPass>

    <Footer class="footer-wrap"></Footer>
  </div>
</template>

<script>
import LoginTempl from '@/components/LoginTempl/index'
import Footer from '@/layout/components/Footer'
import ModifyPass from '@/components/ModifyPass/index'
import SetNewPass from '@/components/SetNewPass/index'

import Cookies from 'js-cookie'
import staticInfo from '@/helpers/staticInfo'

import { setToken } from '@/helpers/auth'
import { validPhone } from '@/helpers/validate'
import { SessionStorage } from '@/helpers/storage'

import { JSEncrypt } from 'jsencrypt'

// import indexDB from '@/mixin/indexDB'

export default {
  name: 'Login',
  components: { LoginTempl, Footer, ModifyPass, SetNewPass },
  // mixins: [indexDB],
  data() {
    const validateLoginCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入合法的用户名'))
      } else if (this.form.loginType === 'MOBILE' && validPhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else if (this.errorKeys.indexOf('loginCode') >= 0 || this.errorKeys.indexOf('mobile') >= 0) {
        callback(new Error(this.errorInfo['loginCode'] || this.errorInfo['mobile']))
        this.resetError('loginCode')
      } else {
        callback()
      }
    }

    const validateLoginPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入合法的密码'))
      } else if (this.errorKeys.indexOf('loginPass') >= 0) {
        callback(new Error(this.errorInfo['loginPass']))
        this.resetError('loginPass')
      } else {
        callback()
      }
    }

    const validateVcode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (!this.form.vcodeFlag) {
        callback(new Error('请获取验证码'))
      } else if (this.errorKeys.indexOf('vcode') >= 0) {
        callback(new Error(this.errorInfo['vcode']))
        this.resetError('vcode')
      } else {
        callback()
      }
    }
    return {
      loadingComponent: null,
      env: process.env.VUE_APP_ENV,
      isBtnLoading: false,
      form: {
        loginBizType: 'ALL',
        loginType: 'MOBILE',
        loginPlatform: 'PC',
        loginCode: '',
        loginPass: '',
        vcode: '',
        vcodeFlag: ''
      },
      rules: {
        loginCode: [{ required: true, trigger: ['change'], validator: validateLoginCode }],
        loginPass: [{ required: true, trigger: ['change'], validator: validateLoginPass }],
        vcode: [{ required: true, trigger: ['change'], validator: validateVcode }]
      },
      errorKeys: [],
      errorInfo: {},
      validPhone: validPhone,
      timer: null,
      isShowCountDown: false,
      countDownNum: 60,
      isCodeLoading: false,
      isLoginLoading: false,
      tokenTimer: null,
      isShowModifyPass: false,
      isShowNewPass: false
    }
  },
  computed: {
    logo() {
      // if (this.theme === 'tp') {
      //   return require('@/assets/img/logo-tyreplus.png')
      // } else {
      return require('@/assets/img/logo-notyreplus.png')
      // }
    },
    isLoginBtnDisabled() {
      if (this.form.loginType === 'ACCOUNT') {
        return !this.form.loginCode || !this.form.loginPass
      } else if (this.form.loginType === 'MOBILE') {
        return !this.form.loginCode || !this.form.vcode || !this.form.vcodeFlag
      } else {
        return false
      }
    },
    codeMsg() {
      if (this.isShowCountDown) {
        return `再次发送(${this.countDownNum})`
      } else {
        return '发送验证码'
      }
    }
  },
  watch: {
    isBtnLoading(newValue) {
      if (newValue) {
        this.loadingComponent = this.$loading({
          lock: this.isMobile,
          spinner: 'blank',
          background: 'rgba(0,0,0,0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
    // myDB(val) {
    //   if (val && this.isIndexDBEnable) { // 登录页清除掉indexDB数据
    //     this.clearIndexDB('customers')
    //   }
    // }
  },
  mounted() {
    this.$store.dispatch('user/REMOVE_TOKEN')

    const theme = 'nt'
    window.document.documentElement.setAttribute('data-theme', theme)
    SessionStorage.setItem('data-theme', theme)
    this.$store.dispatch('apps/SET_THEME', theme)
  },
  methods: {
    noSMSCode() {
      this.gtag('event', 'tips_sms_not_received')

      const h = this.$createElement
      this.$msgbox({
        title: '',
        message: h('p', { style: 'text-align: justify' }, [
          h('span', null, '如果长时间没有收到验证码，您可以拨打咨询：'),
          h('br', null, ''),
          h('i', { class: 'point' }, `${staticInfo.NT.Tel_HotLine}（米其林）`),
          h('span', { class: 'point' }, '/ '),
          h('i', { class: 'point' }, `${staticInfo.TP.Tel_HotLine}（驰加)`)
          // h('br', null, ''),
          // h('i', { class: 'point', style: 'font-size: 22px' }, ' ${热线} '),
          // h('span', null, '咨询')
        ]),
        showCancelButton: false,
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn'
      }).then(action => {})
    },
    forgetPass() {
      this.form.loginType = 'MOBILE'

      this.gtag('event', 'tips_forget_pwd')
    },
    resetError(val) {
      if (val) {
        const index = this.errorKeys.indexOf(val)
        this.errorKeys.splice(index, 1)
        delete this.errorInfo.val
      } else {
        this.errorKeys = []
        this.errorInfo = {}
      }
    },
    selectLoginType(val) {
      switch (val) {
        case 'ACCOUNT':
          // this.form.vcode = ''
          // this.form.vcodeFlag = ''
          this.form.loginType = val
          clearInterval(this.timer)
          this.countDownNum = 60
          this.isShowCountDown = false
          break
        case 'MOBILE':
          // this.form.loginPass = ''
          this.form.loginType = val
          break
        default:
          // this.form.loginType = 'ACCOUNT'
          // this.$message.error('未开通，敬请期待！')
          this.$notify.info({ title: '未开通', message: '功能开发中，敬请期待！' })
      }
    },
    getVerificationCode() {
      this.isBtnLoading = true
      this.isCodeLoading = true

      this.$api.login.getVCode({
        loginBizType: 'ALL',
        mobile: this.form.loginCode,
        businessType: 'BIZ_LOGIN'
      }).then(res => {
        this.gtag('event', 'usr_sms_send_success')

        this.isBtnLoading = false
        this.isCodeLoading = false
        this.form.vcodeFlag = res.data.vcodeFlag

        if (!this.form.vcodeFlag) return
        if (res.data.vcode) {
          this.form.vcode = res.data.vcode
        }
        this.isShowCountDown = true
        this.timer = setInterval(() => {
          this.countDownNum--
          if (this.countDownNum <= 0) {
            clearInterval(this.timer)
            this.countDownNum = 60
            this.isShowCountDown = false
          }
        }, 1000)
      }).catch(err => {
        // 获取验证码失败
        clearInterval(this.timer)
        this.countDownNum = 60
        this.isShowCountDown = false
        this.isBtnLoading = false
        this.isCodeLoading = false

        if (err.errorInfos && err.errorInfos.length > 0) {
          this.resetError()
          err.errorInfos.forEach(item => {
            this.errorKeys.push(item.key)
            this.errorInfo[item.key] = item.errMsg
          })

          this.$refs['dataForm'].validate(valid => {
            console.log(valid)
          })
        }
      })
    },
    encryptStr(val) {
      const publicKey = process.env.VUE_APP_PUBLIC_KEY
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(publicKey)
      const result = encrypt.encrypt(val)

      // console.log(result)
      return result
    },
    clickLoginBtn() {
      console.log(this.form)

      this.$refs['dataForm'].validate((valid) => {
        if (!valid || (this.form.loginType === 'MOBILE' && !this.form.vcodeFlag)) return

        this.isBtnLoading = true
        this.isLoginLoading = true
        const data = { ...this.form }
        if (this.form.loginType === 'ACCOUNT') {
          data.loginPass = this.encryptStr(data.loginPass)
        }
        this.$api.login.webLogin(data).then(res => {
          // console.log('customers---length---', res.data.customers.length)
          // 替换token
          setToken(res.data.token)
          // SessionStorage.setItem('accessToken', res.data.accessToken)
          // SessionStorage.setItem('accessTokenTimeout', res.data.accessTokenTimeout)

          // 设置accessToken
          let date = new Date().getTime()
          date += res.data.accessTokenTimeout * 1000
          const accessTokenTimeout = new Date(date)
          Cookies.set('accessToken', res.data.accessToken, { expires: accessTokenTimeout })
          Cookies.set('dcp-token', res.data.token)

          this.$store.dispatch('user/SET_ACCESS_TOKEN', {
            token: res.data.token,
            accessToken: res.data.accessToken,
            accessTokenTimeout: res.data.accessTokenTimeout
          })
          this.$store.dispatch('user/SET_ROLE', res.data.currDcpRoles || [])
          this.$store.dispatch('user/SET_ROLE_TYPE', res.data.customerConditionType || '')
          this.$store.dispatch('user/SET_ACCOUNT_INFO', res.data.accountInfo || {})
          this.$store.dispatch('user/SET_MANAGE_AREA', res.data.customerConditions || [])
          this.$store.dispatch('user/SET_PROGRAM_TYPE_LIST', res.data.programTypeConditions || [])
          this.$store.dispatch('user/SET_AGREEMENTS', res.data.agreements || [])

          // if (this.isIndexDBEnable) { // 可使用indexDB
          //   SessionStorage.setItem('customersSlice', res.data.customers.slice(0, 24).map(item => item))
          //   res.data.customers.forEach(item => {
          //     this.addIndexDB('customers', item)
          //   })
          // } else {
          //   this.$store.dispatch('user/SET_STORES_LIST', res.data.customers || [])
          // }

          this.isBtnLoading = false
          this.isLoginLoading = false

          // if (res.data.accountInfo.firstLoginFlag === 'Y') { // 初次登录设置密码
          //   this.isShowNewPass = true
          // } else {
          // if (res.data.accountInfo.modifyPassFlag === 'Y') { // 密码到期需要更换
          // this.isShowModifyPass = true

          // } else {
          this.$nextTick(() => {
            this.$router.push({ path: '/stores' })
          })
          // }
          // }

          // if (window.analytics) {
          //   window.analytics.setUserProperties({
          //     'dealerId': '',
          //     'externalId': res.data.accountInfo.accountUuid,
          //     'role': res.data.currDcpRoles[0].roleName,
          //     'salesTerritory': ''
          //   })
          // }

          if (this.form.loginType === 'MOBILE') {
            this.gtag('event', 'usr_sms_login_success')
          } else {
            this.gtag('event', 'usr_pwd_login_success')
          }

          this.gtag('event', 'setUserProperties', {
            'dealerId': '',
            'externalId': res.data.accountInfo.accountUuid,
            'role': res.data.currDcpRoles[0].roleName,
            'salesTerritory': ''
          })
        }).catch(err => {
          console.log(err)
          this.isBtnLoading = false
          this.isLoginLoading = false
          if (err.errorInfos && err.errorInfos.length > 0) {
            this.resetError()
            err.errorInfos.forEach(item => {
              this.errorKeys.push(item.key)
              this.errorInfo[item.key] = item.errMsg

              if (item.errCode === 'loginPass_is_expire') {
                this.$alert('您的密码已过期，您可以使用短信验证方式登录DCP。只有更新密码后方可使用密码登录。', {
                  confirmButtonText: '确定',
                  center: true,
                  customClass: 'dcp-message-box',
                  confirmButtonClass: 'dcp-message-box-confirm-btn',
                  callback: action => {}
                })
              }
            })

            this.$refs['dataForm'].validate(valid => {
              console.log(valid)
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden-wrap {
  position: relative;

  .hidden-modal {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
  }

  .hidden-inner {
    z-index: -10;
  }

  .hidden-input {
    height: 1px;
  }
}

.login-container {
  position: relative;
  width: 100%;
  min-width: $pageInnerWidth;
  // height: calc(100vh - #{$footerHeight});
  min-height: 100%;
  // overflow: hidden;
  padding-bottom: $footerHeight + 20px;
}

.footer-wrap {
  position: absolute;
  bottom: 0;
}

.left-content {
  position: relative;
  // padding-top: 80px;

  .logo {
    position: absolute;
    top: -70px;
    left: 30px;
    width: auto;
    height: 40px;
  }

  .title-wrap {
    // margin-bottom: 120px;

    .sys-logo {
      font-size: 100px;
    }

    .sys-title {
      font-weight: 600;
      font-size: 24px;
      line-height: 33px;
    }
    .sys-env {
      float: left;
      width: 100%;
      font-weight: 600;
      font-size: 28px;
    }
  }

  @include color_page_primary('color');
}

.form-container {
  position: relative;
  width: 383px;
  height: 380px;
  padding-top: 40px;
  margin: 0 auto;

  /deep/ .el-form-item {
    .el-form-item__label {
      width: 100%;
      padding: 0;
      font-size: 14px;
      text-align: left;

      &::before {
        content: '';
      }

      @include color_page_primary('color');
    }

    .el-input__inner {
      padding: 0;
      border: none;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-radius: 0;

      @include border_color_page_primary("color");
    }

    // 更改clear图标
    .el-input__suffix {
      .el-icon-circle-close {
        font-size: 20px;

        &::before {
          content: "\e6db";
        }

        @include color_page_primary("color");
      }
    }
  }

  .forget-tips {
    position: absolute;
    bottom: -41px;
    right: 0;
    font-size: 14px;
    text-align: right;
    cursor: pointer;

    @include color_page_primary('color');
  }

  .code {
    box-sizing: border-box;
    width: 54%;
    margin-right: 6%;
  }

  .code-btn {
    width: 40%;

    @include btn_page_primary('color');
  }

  .login-btn-wrap {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .login-btn {
    width: 100%;
    height: 49px;
    margin-top: 30px;
    font-size: $fontSizeBase;

    @include btn_page_primary('color');
  }
}

.login-channel-container {
  margin-top: 10px;
  text-align: center;

  .channel-title {
    position: relative;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    &::after {
      position: absolute;
      bottom: -8px;
      left: 50%;
      width: 28px;
      height: 2px;
      transform: translateX(-50%);
      content: '';

      @include background_color_page_primary('color');
    }

    @include color_page_primary('color');
  }

  .channel-content {
    display: flex;
    justify-content: space-around;
    width: 300px;
    margin: 20px auto 0;

    .channel-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 64px;
      height: 64px;
      border: 1px solid #8ab6ff;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;

      .channel-icon {
        width: 80%;
        height: 80%;
      }

      @include login_channel_icon('color');
    }
  }
}

</style>
